export default "__VITE_ASSET__DAcrmPzh__"